import { jsx as _jsx } from "react/jsx-runtime";
import { List as MuiList } from '@mui/material';
export var List = function (_a) {
    var children = _a.children;
    return _jsx(MuiList, { className: "localina-list", children: children });
};
